import { ReactNode } from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import DocumentType from 'modules/core/components/DocumentType'

export function UploadResult({
  file,
  onDelete,
  children,
}: {
  file: File
  onDelete(): void
  children: ReactNode
}) {
  return (
    <Box
      border={{ all: { color: 'grey400', style: 'solid', width: 's1' } }}
      borderRadius={{
        all: 'abs008',
      }}
      gap="s8"
      paddingY="s12"
      paddingX="s16"
    >
      <Box flexDirection="row" gap="s16" alignItems="center" justifyContent="spaceBetween">
        <DocumentType mimetype={file.type} />
        <Box gap="s2" flexGrow>
          <Text weight="medium" size="300">
            {file.name}
          </Text>
          {children}
        </Box>
        <Button type="secondary" onClick={onDelete} iconName="delete" />
      </Box>
    </Box>
  )
}
